import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=378e0ac2&scoped=true"
import script from "./DateFilter.vue?vue&type=script&lang=js"
export * from "./DateFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378e0ac2",
  null
  
)

export default component.exports